var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_material-arrow-forward","data-name":"Icon material-arrow-forward","d":"M18,6,15.885,8.115l8.37,8.385H6v3H24.255l-8.37,8.385L18,30,30,18Z","transform":"translate(-6 -6)"}));
}

ArrowRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
